import * as React from 'react'
import type { SVGProps } from 'react'
const SvgCloudSimpleDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 18.584c1.7659-.7716 3-2.5337 3-4.584 0-2.7614-2.2386-5-5-5a5 5 0 0 0-1.5614.2486C14.3696 6.7504 11.8892 5 9 5c-3.866 0-7 3.134-7 7 0 2.3787 1.1865 4.4804 3 5.7453M12 14v5.25m2.5-1.75L12 20l-2.5-2.5"
    />
  </svg>
)
export default SvgCloudSimpleDownload
